
import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import { isNull } from "../../../../../shared/lib/html5-software-library/src/ranj/util/TypeUtil";
import { applySearchParametersToObject, getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AssetLibrary from "../../../../../shared/src/ranj/app/assetloading/AssetLibrary";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import GameConfig from "../model/GameConfig";
import GameModel from "../model/GameModel";

export default class InitAccuracyGameTask extends Task {

    /**
     * @param {AssetLibrary} assetLibrary 
     * @param {GameConfig} gameConfig 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, assetLibrary, gameConfig, gameModel) {
        super();

        this.execute = function(callback, progressCallback) {
            var configJSON = assetLibrary.getAsset("gameConfig");
            if (ranj.DEBUG) {
                applySearchParametersToObject(window.top.location.search, configJSON);
                window.document.addEventListener("keyup", this._handleKeyUp);
            }
            gameConfig.setPropertiesFromObject(configJSON);

            gameModel.initialize();

            if (ranj.DEBUG) {
                window.gameconfig = gameConfig;
                window.gamemodel = gameModel;

                const n = parseInt(getURLParameter("create"));
                if (!isNaN(n)) {
                    this.createPuzzles(n);
                }
            }

            callback(this);
        }

        this._handleKeyUp = function(e) {
            const c = String.fromCharCode(e.which);
            if (c == "R") {
                if (confirm("Are you sure you want to reset the savegame?")) {
                    dispatcher.dispatch(SaveEvent.CLEAR);
                    window.location.reload();
                }
            }
        }.bind(this);
    }


    createPuzzles(n = 30, itemCount = 42, boxSize = 6, poolSize = 18) {
        const items = [];
        for (let i = 0; i < itemCount; i++) items.push(i);

        const puzzles = [];
        for (let i = 0; i < n; i++) {
            const shuffled = ArrayUtil.shuffle(items.slice(0)).slice(0, poolSize);
            const goal = ArrayUtil.shuffle(shuffled.slice(0)).slice(0, boxSize);
            puzzles.push({
                goal: goal,
                items: shuffled
            });
        }
        console.log(JSON.stringify(puzzles));
    }

    generateItemFeatureList() {
        //For use in console
        const regex = /[A-Z][a-z]*/g;
        const lines = [];
        ["BlockBlackTriangle", "BlockBlackStar", "BlockBlackSquare", "BlockBlackHeart", "BlockBlackCross", "BlockBlackCircle", "BlockGreenTriangle", "BlockGreenStar", "BlockGreenSquare", "BlockGreenHeart", "BlockGreenCross", "BlockGreenCircle", "BlockBlueTriangle", "BlockBlueStar", "BlockBlueSquare", "BlockBlueHeart", "BlockBlueCross", "BlockBlueCircle", "BlockWhiteTriangle", "BlockWhiteStar", "BlockWhiteSquare", "BlockWhiteHeart", "BlockWhiteCross", "BlockWhiteCircle", "BlockPurpleTriangle", "BlockPurpleStar", "BlockPurpleSquare", "BlockPurpleHeart", "BlockPurpleCross", "BlockPurpleCircle", "BlockOrangeTriangle", "BlockOrangeStar", "BlockOrangeSquare", "BlockOrangeHeart", "BlockOrangeCross", "BlockOrangeCircle", "BlockYellowTriangle", "BlockYellowStar", "BlockYellowSquare", "BlockYellowHeart", "BlockYellowCross", "BlockYellowCircle"].forEach(id => {
            const parts = id.match(regex);
            const fg = parts[1].toLowerCase();
            const shape = parts[2].toLowerCase();
            const line = `"${id}": { "backgroundColor": "", "foregroundColor": "${fg}", "shape": "${shape}" }`;
            lines.push(line);
        });
        console.log(lines.join(",\n"));
    }
}


const ArrayUtil = {};
ArrayUtil.shuffle = function(a) {
    let j, x, i;
    for (i = a.length; i; i--) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
    }
    return a;
}